// Remember this device: skip the two-step code on this computer for 30 days.
//
// Stores a per-user+device token in localStorage that lets the user skip the
// 2FA prompt for 30 days. Cleared on "Sign out everywhere" or when device is
// untrusted server-side (future feature).
//
// Moved out of login.js unchanged (2026-10-06) so the CRM's own code step
// (modules/two-step-gate.js) honours the same choice the sign-in page offers.

export function deviceTrustKey(userId) { return `revfit_trusted_device_${userId}`; }
export function isDeviceTrusted(userId) {
  try {
    const raw = localStorage.getItem(deviceTrustKey(userId));
    if (!raw) return false;
    const { exp } = JSON.parse(raw);
    return typeof exp === 'number' && exp > Date.now();
  } catch { return false; }
}
export function trustThisDevice(userId) {
  const THIRTY_DAYS_MS = 30 * 86400000;
  try {
    localStorage.setItem(deviceTrustKey(userId), JSON.stringify({ exp: Date.now() + THIRTY_DAYS_MS }));
  } catch {}
}
